import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Esta página es oficial de Consalud?',
      answer: 'No, este es mi sitio web personal de orientación y acompañamiento comercial. No corresponde al sitio oficial de Consalud. Trabajo como ejecutiva vinculada a la isapre, pero la contratación y formalización de productos se realiza por los canales autorizados oficiales.'
    },
    {
      question: '¿Puedo resolver dudas sobre planes y beneficios?',
      answer: 'Sí, por supuesto. Te ayudo a entender las diferencias entre planes, coberturas, bonificaciones y beneficios. Mi objetivo es que tengas toda la información clara para tomar la mejor decisión.'
    },
    {
      question: '¿La orientación tiene costo?',
      answer: 'No, la orientación y asesoría que brindo no tiene costo. Es parte del servicio de acompañamiento que ofrezco para ayudarte a entender y gestionar mejor tu salud previsional.'
    },
    {
      question: '¿Dónde es la atención?',
      answer: 'La atención presencial es en Santiago. Si estás en otra región de Chile, también puedo atenderte sin problema a través de videollamada. La distancia no es un obstáculo para orientarte y resolver tus dudas.'
    },
    {
      question: '¿Cómo puedo contactarte?',
      answer: 'Puedes escribirme directamente por WhatsApp haciendo clic en el botón de contacto, o completar el formulario en esta página. Respondo rápidamente y estoy disponible para resolver tus dudas.'
    },
    {
      question: '¿Qué pasa después de contratar un plan?',
      answer: 'No te dejo solo. Ofrezco seguimiento y apoyo postventa para resolver cualquier duda que surja sobre tu plan, beneficios o gestiones. Estoy disponible cuando me necesites.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-6">
            <span className="text-sm font-medium text-blue-600">Preguntas frecuentes</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Resuelve tus dudas
          </h2>
          <p className="text-lg text-gray-700">
            Aquí encontrarás respuestas a las preguntas más comunes
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:border-blue-200 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-blue-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">¿Tienes otra pregunta?</p>
          <button
            onClick={() => window.open('https://wa.me/56944540956', '_blank')}
            className="inline-flex items-center space-x-2 px-8 py-4 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-all hover:shadow-lg whitespace-nowrap"
          >
            <i className="ri-question-answer-line text-xl"></i>
            <span className="font-medium">Pregúntame directamente</span>
          </button>
        </div>
      </div>
    </section>
  );
}